// Upload de imagens direto para o Cloudinary (upload "unsigned").
// Os valores abaixo são públicos por natureza (podem ficar no frontend).
// Configure em variáveis de ambiente REACT_APP_CLOUDINARY_* (Render/local).
const CLOUD_NAME    = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export const cloudinaryConfigured = Boolean(CLOUD_NAME && UPLOAD_PRESET);

export async function uploadToCloudinary(file) {
  if (!cloudinaryConfigured) {
    throw new Error('Envio de arquivos não configurado. Defina REACT_APP_CLOUDINARY_CLOUD_NAME e REACT_APP_CLOUDINARY_UPLOAD_PRESET.');
  }

  const form = new FormData();
  form.append('file', file);
  form.append('upload_preset', UPLOAD_PRESET);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
    method: 'POST',
    body: form,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error?.message || 'Falha no upload da imagem.');
  }
  return data.secure_url;
}
